import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  const displayCategories = categories.filter((c) => c.slug !== 'all');

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            按类型找到您感兴趣的韩国漫画
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-4">
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-50 hover:bg-primary-500 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 group-hover:bg-white/20 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl text-primary-500 group-hover:text-white transition-colors`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-800 group-hover:text-white transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400 group-hover:text-white/70 transition-colors text-center hidden sm:block">
                {cat.description}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}